import { render, staticRenderFns } from "./DepartmentsView.vue?vue&type=template&id=4870909d"
import script from "./DepartmentsView.vue?vue&type=script&lang=js"
export * from "./DepartmentsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports